import React from "react";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Switch from "@mui/material/Switch";
import Tooltip from "@mui/material/Tooltip";
import {useMediaQuery} from "react-responsive";
import {mediaQueryForMobile} from "../HomePage/HomePage";
import {useDefaultQuoteSettingsContext} from "../../contexts/DefaultQuoteSettingsContext";

export const DefaultSettingsRebatesTax = () => {
    const isTabletOrMobile = useMediaQuery({ query: mediaQueryForMobile })
    const { quoteSettings, setSettingsStateWithUpdate } = useDefaultQuoteSettingsContext()

    return (
        <TableRow
            key={'Sales Tax'}
            sx={{
                '&:last-child td, &:last-child th': {border: 0},
                height: '10px',
            }}
            className={'default-settings-fee'}
        >

            <TableCell
                className={'DealPageFee fee-name'}
                scope="row"
                size={'small'}
                width={isTabletOrMobile ? '60%' : '40%'}
                align="left"
            >
                <div
                    style={{
                        display: 'flex',
                        flexDirection: "row",
                        alignItems: 'center',
                        justifyContent: 'space-between',
                    }}
                >
                    Rebates Tax
                </div>
            </TableCell>
            {/* Empty spacer so Capped lands in the same column as the Fees Capped */}
            { !isTabletOrMobile && <TableCell className={'DealPageFee'} size={'small'} width={'20%'}/> }
            <TableCell
                className={'DealPageFee'}
                align="center"
                size={'small'}
                width={'20%'}
            >
                <Tooltip title={quoteSettings.is_rebate_tax_capped ? 'Upfront' : 'Cap'} arrow placement={'top'}>
                    <Switch
                        checked={quoteSettings.is_rebate_tax_capped}
                        onChange={() => {
                            setSettingsStateWithUpdate({is_rebate_tax_capped: !quoteSettings.is_rebate_tax_capped}, true)
                        }}
                    />
                </Tooltip>

            </TableCell>
            { !isTabletOrMobile && <TableCell className={'DealPageFee'} size={'small'} width={'20%'}/> }
        </TableRow>
    )
}